import { render, staticRenderFns } from "./DCNotesUploadPhotoView.vue?vue&type=template&id=159680e8&scoped=true&"
import script from "./DCNotesUploadPhotoView.vue?vue&type=script&lang=js&"
export * from "./DCNotesUploadPhotoView.vue?vue&type=script&lang=js&"
import style0 from "./DCNotesUploadPhotoView.vue?vue&type=style&index=0&id=159680e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159680e8",
  null
  
)

export default component.exports